import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: '', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: '', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: '',
  subtitle: '',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'profile.png',
  paragraphOne: '',
  paragraphTwo: '',
  paragraphThree: '',
  resume: 'https://www.resumemaker.online/es.php', // if no resume, the button will not show up
};

// PROJECTS DATA
export const projectsData = [
  {
    id: nanoid(),
    img: 'sakneen.jpg',
    position: 'Software engineer',
    title: 'Sakneen',
    info: `<strong> Sakneen </strong> is Egypt's best real estate search experience. Search for your next home by down payment, monthly payment, delivery date and finishing type.`,
    date: '1/1/2021 -',
    tech: [
      '<strong>Express</strong> for setting up servers',
      `<strong>Mongo</strong> as the database layer and <strong>mongoose</strong> as the ODM`,
      '<strong>Mocha</strong> and <strong>chai</strong> for unit and integration testing',
      '<strong>Google Cloud Services</strong> for hosting services',
      '<strong>Elastic search</strong> for searching',
      '<strong>RabbitMQ</strong> For asynchronous messaging',
    ],
    url: 'https://www.sakneen.com/en',
  },
  {
    id: nanoid(),
    img: 'shezlong.jpg',
    position: 'Software engineer',
    title: 'Shezlong',
    info: `Talk anonymously to the top psychiatrists in Egypt in any time from anywhere. Book you session by <strong> Shezlong </strong>. Book a session Now. Types: Depression disorders, Anxiety disorders, Marriage Counselling.`,
    date: '1/10/2020 - 1/1/2021',
    tech: [
      '<strong>Loopback</strong> for establishing the back end rest API',
      '<strong>MariaDB</strong> for the database layer',
    ],
    url: 'https://www.shezlong.com/en/',
  },
  {
    id: nanoid(),
    img: 'coligo.jpg',
    position: 'Software engineer',
    title: 'Coligo',
    info: `We offer technology solutions for schools and organizations throughout their digital transformation journey, specializing in education technology, enterprise resource planning (ERP), business operations optimization and automation, advanced data analytics, IT infrastructure and security.`,
    tech: [
      '<strong>Express</strong> for establishing the backendAPI',
      '<strong>AWS</strong> for hosting services',
      '<strong>Mongo</strong> for the database layer',
      '<strong>Jest</strong> for unit and integration testing',
      '<strong>AWS S3</strong> for file storage',
      '<strong>LogDNA</strong> for log aggregation',
    ],
    date: '1/12/2019 - 1/11/2020',
    url: 'https://web.coligotech.com/',
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: '',
};

// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'hackerrank',
      url: 'https://www.hackerrank.com/khaledosama52',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: 'https://www.linkedin.com/in/khaled-osama-565a75197/',
    },
    {
      id: nanoid(),
      name: 'github',
      url: 'https://github.com/khaledosama999',
    },
    {
      id: nanoid(),
      name: 'briefcase',
      url: 'https://www.upwork.com/freelancers/~019325192c4a724013?viewMode=1',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: false, // set to false to disable the GitHub stars/fork buttons
};
